module.exports = __webpack_public_path__ + "img/1451112935.539a75ad.jpg";